import { Box, Flex, HStack, Heading, Image, Text } from "@chakra-ui/react";
import parse from "html-react-parser";
import { FC } from "react";

import salaryIcon from "assets/bill.svg";
import calendarIcon from "assets/calendar.svg";
import locationIcon from "assets/location.svg";
import { jobPostTime } from "utils/jobs";

interface IJobDescription {
  jobData: any;
}

const JobDescription: FC<IJobDescription> = ({ jobData }) => {
  return (
    <>
      <Flex borderY="2px solid rgba(128,128,128, 0.45)" py={4} mb={6} gap={2}>
        <HStack flex={1}>
          <Image
            src={locationIcon}
            alt="map pin"
            width={[5, 5, "initial"]}
            height={[5, 5, "initial"]}
          />
          <Text fontWeight={600} fontSize={{ base: 14, md: 16 }}>
            {jobData?.JobCity}, {jobData?.State}
          </Text>
        </HStack>
        <HStack flex={1}>
          <Image
            src={calendarIcon}
            alt="calendar icon"
            width={[5, 5, "initial"]}
            height={[5, 5, "initial"]}
          />
          <Text fontWeight={600} fontSize={{ base: 14, md: 16 }}>
            {jobPostTime(new Date(jobData?.jobActiveDate))}
          </Text>
        </HStack>

        {jobData?.salary != null &&
          jobData?.salary !== "NaN" &&
          jobData?.salary?.length > 0 && (
            <HStack flex={1}>
              <Image
                src={salaryIcon}
                alt="salary icon"
                width={[5, 5, "initial"]}
                height={[5, 5, "initial"]}
              />
              <Text fontSize={{ base: 14, md: 16 }} fontWeight={600}>
                {jobData?.salary}
              </Text>
            </HStack>
          )}
      </Flex>
      <Heading as="h6" fontSize={[14, 14, 18, 24]} mb={4}>
        Description
      </Heading>
      {(jobData as boolean) && (
        <Box className="pb-14" fontSize={{ base: 16, md: 18 }}>
          {" "}
          {parse(jobData?.JobBody)}
        </Box>
      )}
    </>
  );
};

export default JobDescription;
